import { HgSupportedLanguage } from '@smg-real-estate/domus';

export const BASE_PATH = {
  en: '/en/price-check/:listingId',
  de: '/de/price-check/:listingId',
  fr: '/fr/price-check/:listingId',
  it: '/it/price-check/:listingId',
};

export const VALIDATION_ERROR_PATH = {
  en: '/en/price-check/validation-error',
  de: '/de/price-check/validation-error',
  fr: '/fr/price-check/validation-error',
  it: '/it/price-check/validation-error',
};

export const HG_ACCOUNT_BASE_PATH = 'https://www.homegate.ch';
export const HG_BASE_PATH = 'https://www.homegate.ch';
export const IS24_BASE_PATH = 'https://www.immoscout24.ch';

// TODO: delete this when cleaning up the services
export const ARTICLE_API_PATH = (language: HgSupportedLanguage) =>
  `/c/api/${language}/teaserpool/teaser-pool-propertyevaluation.json`;
